import React from 'react';
import DesktopAccessDisabledIcon from '@material-ui/icons/DesktopAccessDisabled';
import PerfectScrollbar from 'react-perfect-scrollbar';

const styleObj = {
  position: 'fixed',
  top: '10%',
  left: '40%',
  textAlign: 'center',
};
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    console.error(error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <PerfectScrollbar>
          <div style={styleObj}>
            <DesktopAccessDisabledIcon style={{ color: 'red', fontSize: 50, marginBottom: 10 }} />
            <h3>Something went wrong</h3>
            <p>Please try after sometime</p>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state?.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo?.componentStack}
            </details>
          </div>
        </PerfectScrollbar>
      );
    }

    return this.props.children;
  }
}
